export const getParentDir = (url: string) => {
  const findIndex = url.indexOf("/", 1);
  const result = url.substring(0, findIndex + 1);
  return result;
};
